import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import { getUnreadMessageCount } from "../queryFunctions/getUnreadMessageCount";
import { messagingKeys } from "../keyFactory";

const isPollingEnabled = process.env.REACT_APP_ENABLE_MESSAGE_NOTIFICATIONS_UPDATE === "true";
const pollingInterval = parseInt(
  process.env.REACT_APP_ENABLE_MESSAGE_NOTIFICATIONS_UPDATE_REFRESH_TIME ?? "0",
  10,
);

type UseUnreadMessageCountProps<TData = number> = {
  enabled?: boolean;
  select?: (data: number) => TData;
};

type UnreadMessageCountQueryOptions = UseQueryOptions<
  number,
  unknown,
  number,
  ReturnType<typeof messagingKeys.count>
>;

export function useUnreadMessageCount<TData = number>({
  enabled = true,
  select,
}: UseUnreadMessageCountProps<TData> = {}) {
  return useQuery({ ...optionFactory(enabled), select });
}

function optionFactory(enabled = true) {
  const refetchInterval = isPollingEnabled && pollingInterval > 0 ? pollingInterval : false;

  return {
    enabled,
    queryFn: getUnreadMessageCount,
    queryKey: messagingKeys.count(),
    refetchInterval,
    refetchIntervalInBackground: false,
  } satisfies UnreadMessageCountQueryOptions;
}
